import { NEWSLETTER_CONSENT_TEXT, type NewsletterSubscribeVariant } from '@tipi/shared'

export { NEWSLETTER_CONSENT_TEXT }

export const newsletterCopy = {
    eyebrowArticle: 'Novedades Tipi · un email a la semana',
    eyebrowHubLanding: 'Novedades Tipi',
    titleArticle: '¿Te ha servido? Cada semana, lo que de verdad afecta a tu negocio.',
    titleHubAprender: 'Una guía nueva cada semana, sin tener que venir a buscarla.',
    titleHubActualidad: 'Lo que cambia en hostelería, explicado antes de que te pille.',
    titleLanding: '¿Aún no es momento de pedir demo? Quédate cerca.',
    subtitleArticle: 'Guías de costes, cambios normativos y lo nuevo de Tipi. Cinco minutos de lectura, sin spam.',
    subtitleHub:
        'Todo lo que publicamos en Aprender y Actualidad hostelera, más lo nuevo de Tipi. Cinco minutos, cada domingo.',
    subtitleLanding:
        'Cada semana, una guía para bajar costes, lo que cambia en la normativa y lo nuevo de Tipi. Cuando quieras hablar, aquí estaremos.',
    ctaDefault: 'Suscribirme',
    ctaLanding: 'Quiero recibirlo',
    ctaLoading: 'Apuntándote…',
    emailLabel: 'Tu email',
    emailPlaceholder: 'nombre@turestaurante.es',
    consent: NEWSLETTER_CONSENT_TEXT,
    legalBeforeLink:
        'Tipi usará tu email solo para enviarte esta newsletter. Nada de llamadas comerciales. Más info en la ',
    legalLink: 'política de privacidad',
    legalAfterLink: '.',
    successEyebrow: 'Oído cocina',
    successTitle: 'Revisa tu correo.',
    successBodyBefore: 'Si te acabamos de apuntar, te hemos enviado un email a ',
    successBodyAfter:
        '. Confírmalo y te llegará el próximo número. Si no lo ves, mira en Promociones o Spam. Si ya estabas suscrito, seguirás recibiendo Novedades Tipi.',
    useAnotherEmail: 'Usar otro email',
    errorEmail: 'Revisa el email: parece que le falta algo (ej. nombre@turestaurante.es).',
    errorConsent: 'Marca la casilla para que podamos enviarte la newsletter.',
    errorServer: 'No hemos podido apuntarte ahora mismo. Vuelve a intentarlo en un minuto.',
} as const

export function resolveNewsletterTitle({
    variant,
    hub,
}: {
    variant: NewsletterSubscribeVariant
    hub?: 'aprender' | 'actualidad'
}) {
    if (variant === 'landing') return newsletterCopy.titleLanding
    if (variant === 'hub') {
        return hub === 'actualidad' ? newsletterCopy.titleHubActualidad : newsletterCopy.titleHubAprender
    }
    return newsletterCopy.titleArticle
}

export function resolveNewsletterSubtitle(variant: NewsletterSubscribeVariant) {
    if (variant === 'landing') return newsletterCopy.subtitleLanding
    if (variant === 'hub') return newsletterCopy.subtitleHub
    return newsletterCopy.subtitleArticle
}

export function resolveNewsletterEyebrow(variant: NewsletterSubscribeVariant) {
    return variant === 'article' ? newsletterCopy.eyebrowArticle : newsletterCopy.eyebrowHubLanding
}

export function resolveNewsletterCta(variant: NewsletterSubscribeVariant) {
    return variant === 'landing' ? newsletterCopy.ctaLanding : newsletterCopy.ctaDefault
}
